import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence, GoogleAuthProvider } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDWT0KG9sPfchazFeV-OZTE-QdQ74HORfs",
  authDomain: "fundraising-donor-platform-swg.firebaseapp.com",
  projectId: "fundraising-donor-platform-swg",
  storageBucket: "fundraising-donor-platform-swg.firebasestorage.app",
  messagingSenderId: "326797982053",
  appId: "1:326797982053:web:d8afe8e04161cfc9ec098c"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();
const functions = getFunctions(app);
const projectId = firebaseConfig.projectId;
const realtimeDb = getDatabase();

// Ensure the user session persists across refresh
setPersistence(auth, browserLocalPersistence);

//export default db;

export { db, auth, googleProvider, functions, projectId, realtimeDb, httpsCallable};